import { useEffect, useState } from "react";
import { HeadlineTypeEnum } from "../../assets/utils/enums/headline";
import { ThemeTypeEnum } from "../../assets/utils/validation/types";
import AppLayout from "../../components/layout/app/layout";
import Headline from "../../components/ui/headline";
import KanbanBoard from "../../components/ui/kanban-board/kanban-board";
import getData from "../../api/project-request";
import { API_URL_SELLING } from "../../constants";
import { SellingColumn } from "../../assets/utils/data/selling";

export default function SellingMainPage() {
  const [loaderState, setLoaderState] = useState<boolean>(false);
  const [sellings, setSellings] = useState<SellingColumn[]>([]);

  useEffect(() => {
    const getSellings = async () => {
      setLoaderState(true);
      try {
        const data = await getData(`${API_URL_SELLING}/get-all-selling-by`);

        if (Array.isArray(data)) {
          // setSellings(normalizeKanbanColumns(data));
          setSellings(data);
        } else {
          setSellings([]);
        }
      } catch (error: any) {
        console.log(error.message);
          setSellings([]);
      } finally {
        setTimeout(() => {
          setLoaderState(false);
        }, 100);
      }
    };

    getSellings();
  }, []);

  return (
    <AppLayout className="" blockType="projects" loaderState={loaderState}>
      <Headline
        headline={HeadlineTypeEnum.SELLING}
        theme={ThemeTypeEnum.LIGHT}
        btn_text="Додати запис"
        btn_link="/selling/add"
      />
      <KanbanBoard columns={sellings} setColumns={setSellings} />
    </AppLayout>
  );
}
